import { ReportData, Source } from "../types";

export const generateNewsReport = async (
  date: string,
  onUpdate: (data: ReportData) => void
): Promise<void> => {
  try {
    const response = await fetch('/api/generate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ date }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.error || `Request failed with status ${response.status}`;
      throw new Error(errorMessage);
    }

    if (!response.body) {
      throw new Error("No response body received");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    
    let accumulatedText = "";
    let accumulatedSources: Source[] = [];

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      
      // Keep the last line in the buffer if it's incomplete (doesn't end with \n)
      // Since split removes the separator, if the buffer ended with \n, the last element is empty.
      // If it didn't, the last element is the incomplete line.
      buffer = lines.pop() || "";

      for (const line of lines) {
        if (!line.trim()) continue;
        
        try {
          const data = JSON.parse(line);
          
          if (data.type === 'text') {
            accumulatedText += data.content;
            onUpdate({ markdown: accumulatedText, sources: accumulatedSources });
          } else if (data.type === 'sources') {
             // Merge new sources with existing ones
             const newSources = data.content as Source[];
             accumulatedSources = [...accumulatedSources, ...newSources];
             onUpdate({ markdown: accumulatedText, sources: accumulatedSources });
          }
        } catch (e) {
          console.warn("Failed to parse stream chunk:", line);
        }
      }
    }
    
    // Process any remaining buffer
    if (buffer.trim()) {
      try {
        const data = JSON.parse(buffer);
        if (data.type === 'text') {
            accumulatedText += data.content;
            onUpdate({ markdown: accumulatedText, sources: accumulatedSources });
        }
      } catch (e) {
        // ignore
      }
    }

  } catch (error: any) {
    console.error("API Error:", error);
    if (error.name === 'TypeError' && error.message === 'Failed to fetch') {
       throw new Error("网络请求失败。请检查您的网络连接，或者如果是开发者，请检查CORS配置。");
    }
    throw error;
  }
};
